// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"376":"0d119ecd","6336":"27b105f2","7556":"0d119ecd","8424":"27b105f2"}[chunkId] + ".chunk.css";
};